export const locale = {
    lang: 'en',
    data: {
      'MODALES': {
        'ERROR_DATOS':'An error occurred A-721',
        'VALIDACION':{
          'ERROR1':'You have question without translate',
          'WARNING-SIN-TRADUCCION':'Please add your reagent translation',
          'MODAL-GUARDANDO':'Saving Reactive'
        },
        'TITULO': 'An error ocurred',
        'TITULOS': {
          'error': 'An error ocurred',
          'adver': 'Warning',
          'aviso': 'Warning',
          'opSuc': 'Action completed'
        },
        'ACCIONES': {
          'aceptar' : 'Accept',
          'cancelar': 'Cancel',
          'INFORMATIVO': 'Do not show this message again'
        },
        'EXPEDIENTES':{
          'Resultados': 'You do not have the result yet',
          'CARGANDO_COLABORADORES':'Loading collaborators who need medical supervision',
        },
        'MENSAJES': {
          'NO_FECH_LAN':'Incomplete data, select product release date',
          'NO_RESU_ACTI':'At the moment the results are not available, please try again later.',
          'OK':'OK',
          'Something is wrong': 'Something is wrong',
          'password wrong': 'The password you entered is incorrect',
          'User does not exist': 'The email you entered is not registered in CulturalGO',
          '150': 'the collabs were saved :V',
          'Error: user already exist': 'The user with this email already exist',
          'CONEX': {
            'SIN': 'Your device has lost internet connection\n\nTo continue using the platform, connect your device to the internet',
            'CON': 'Your device has recovered the internet connection\n\nNow you may continue using the platform'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': 'To access this section you must set the <b>languages</b> for the survey',
                'rest2': 'To access this section you must complete all the previous steps',
                'rest3': 'To access this section you must <b>schedule</b> the survey launch',
                'rest4': 'To access this section you must have done the <b>mail sending</b> and the survey must have been launched',
                'rest5': 'To access this section you must set the <b>Demographics</b> for the survey'
              },
              'IDIOMAS': {
                'NADA': 'You have not started the languages selection',
                'NADA2': 'yo have notm release date scheduled yet',
                'NADA4': 'You have not started date reminder yet',
                'NODEFAULT': 'You have not selected the main language yet',
                'NOADICIONAL': 'You have no selected any additional language yet',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current languages selection?',
                '210': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can choose the main language and additional languages in which the survey will be presented to the employees',
                'ARCHIVOCOMFIRM': 'Warning! Be sure to work the Excel file on a single operating system to avoid coding conflicts.',
                'BOTONTEXTO':'Understood',

                'TITULO_DESBLOQUEAR': '<span>Are you sure you want to reopen the language passages, note that this will <font color="red">restart</font> your current product and delete all the information you have added to the sections?</span>',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'In this section you can make changes to the template',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': 'You have not created any NPS or marked the option without NPS',
                'COMPLETAR': 'Are you sure you can complete the step with your current NPS?',
                '219': 'The step was completed successfully',
                '220': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can modify your NPS for the survey',
                'FALTANTES': 'You have not yet completed filling your NPS',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the NPS step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'REACTIVOS': {
                'NADA': 'You have not created any statements or marked the option without statements',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current statements?',
                '218': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can add statements to the survey',
                'FALTANTES': 'You have not yet completed filling your statements',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the statements step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'FORALL': {
                'NADA': 'You have not finished the 4ALL practices filling yet',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current For All practices?',
                '212': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section lists the practices carried out in the company, which involve the participation of all employees',
                'NADA_TRA': 'You have not finished the translate of your 4ALL practices yet',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the 4ALL practices step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'CONTROL': {
                'NADA': 'You have not created any control questions or marked the option without control',
                'COMPLETAR': 'Are you sure you want to complete the step with your current control question?',
                '221': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can modify your survey control question',
                'FALTANTES': 'You have not yet completed filling out your control question',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the control question step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'DEMOGRAFICOS': {
                'NADA': 'You have not yet selected demographics',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current demographic information?',
                '213': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section establishes the demographic options that will be made available to the employees in the survey',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the demographics step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'ABIERTAS': {
                'NADA': 'You have not created any open question or marked the option without open questions',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current open questions?',
                '220': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can add open questions to get your employees written feedback',
                'FALTANTES': 'You have not yet completed filling in your open questions',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the open questions step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'ADICIONALES': {
                'NADA': 'You have not created any additional question or marked the option without additional questions',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current additional questions?',
                '214': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can add custom questions to the survey',
                'FALTANTES_TRADUCCIONES': 'You have not yet completed filling in the translations for all the questions',
                'FALTANTES_SECCIONES_ESPECIALES': 'You have not yet entered the key of the special section',
                'FALTANTES_RESPUESTAS': 'You cannot complete this step yet, all the multiple option questions must have at least two answer options',
                'SIN_PREGUNTAS': 'You need to add at least one question to complete the step',
                'SIN_GRUPOS': 'You need to add at least one question group with a question inside to complete the step',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the additional step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'COLABORADORES': {
                'NADA': 'You have not loaded your participants database',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current participants database?',
                '211': 'The step was completed successfully',
                '200': 'The step was completed successfully',
                '219': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section loads the list of employees to whom the invitation to the survey will be sent via email',
                'ACTUALIZAR': 'Collaborators were correctly added to the survey',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the participants step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'PROGRAMACION': {
                'NADA': 'You have not scheduled a date',
                'COMPLETAR': 'Are you sure to mark this step as completed with the current schedule date?',
                'GENERAR': 'Are you sure to mark this step as completed?',
                '215': 'The step was completed successfully',
                '217': 'The step was completed successfully', //CERTIFICAR2.0
                'COMPLETADO': 'You have already completed this step',
                'FECHALANZAMIENTO': 'You have not yet entered your release date',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'This section establishes the dates for launching and sending reminders for the survey completion',
                'INFORMATIVO2': 'This section sets the dates for sending surveys Pulse Check',
                'GUARDA-OK':'The date was successfully saved',
                'OK':'OK',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the create survey step?',
                'TITULO_DESBLOQUEAR2': 'Are you sure to reopen the scheduled survey step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close',
                'NOT_MESS_COM':'This function is not allowed',
                'DETEC_CAMBIOS_SECCIONES':'Changes were detected in the configuration of the sections, generate the survey again.',
              },
              'ENVIO': {
                'NADA': 'You have not done the survey invitation email sending to your collaborators yet',
                'NADA_OPCION': 'You have not yet configured whether the invitation will be sent by email',
                'COMPLETAR': 'Are you sure to mark this step as completed?',
                '216': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section you can send the pilot survey invitations',

                'TITULO_DESBLOQUEAR': 'Are you sure to reopen the mail sender step?',
                'BOTON_CONFIRM': 'Yes, reopen',
                'BOTON_CANCEL': 'Cancel',
                'SUCCES': 'The step has been successfully reopened',
                'BLOQUEADO': 'The step is now open',
                'CERRAR': 'Close'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': 'In this section you can activate or deactivate the survey.',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': 'The survey is not finished yet',
                'COMPLETAR': 'Are you sure to mark this step as completed?',
                '217': 'The step was completed successfully',
                'COMPLETADO': 'You have already completed this step',
                'RESTRICCION': 'It is not possible to perform this action once you have completed this step',
                'INFORMATIVO': 'In this section the current progress of the survey can be consulted, as well as the early closing of the survey',
                'INFORMATIVO2': 'In this section you can check the current progress of each of the Pulse Check surveys launched'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Warning',
                  'INFO': 'Warning\n\nYour session will be closed and the platform will proceed to login as the selected work center.\n\nDo you confirm to login as the selected work center?',
                  'INFOODS': 'Warning\n\nYour session will be closed and the platform will proceed to login as the selected company.\n\nDo you confirm to login as the selected company?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Not yet authorized ',
              'BTN-ENTERADO':'ENTER',
              'MODAL-AUTORIZACION':'Your survey has been sent to validate',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Your computer or device is presenting a connection failure with the platform, please try to access again later',
          '102': 'The email address entered is not registered in CulturalGO',
          '103': 'The entered password is wrong',
          '101': 'The user with this email already exist',
          // 'verifyToken_3': '<span>The platform has had an update recently, for this reason and to avoid loss of information, then your session will be closed<br><br>To ensure the proper functioning of the platform, before accessing it again we ask you to update your browser with the <font color="red">CTRL + F5</font> key combination.</span>',
          // 'tokenActLogin': '<span>The platform has recently had an update, for this reason and to ensure the correct functioning of the platform, we ask you to update your browser with the key combination <font color="red">CTRL + F5</font>, later you can access the platform normally</span>'
          'verifyToken_3': '<span>The platform has had an update recently, for this reason and to avoid loss of information, then your session will be closed<br><br>To ensure the proper functioning of the platform, <font color="red">your browser will update automatically</font></span>',
          'tokenActLogin': '<span>The platform has recently had an update, for this reason and to ensure the correct functioning of the platform, <font color="red">your browser will update automatically</font>, later you can access the platform normally</span>',
          'Demo keys out of stock': 'Survey demo users have been exhausted',
          'Keys Out Of Stock': 'Survey demo users have been exhausted',
          'Error: Please Recreate Survey':'Changes have been detected in the questions.\n\n To continue,re-create the survey.',
          'IT Manager Not Found':'The email was not sent to the IT manager.\n\nenter the email and send manually',
          'NO_PROCC_PROD_ASO':'The associated product has not been processed at this time',
          'ERR_PROCC_PROD_ACT':'Error updating users in SQL',
          '300':'The entered email does not have access permissions',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>To confirm the disposal of the company ',
          'MENSAJETEXTO2': ', enter the company name in the text box</span>',
          'SALIR': 'Exit',
          'VALIDAR': 'Confirm company',
          'ERRORNOMBREEMPRESA': 'The name of the company entered does not match the name of the company to be deleted',
          'MENSAJE': 'Are you sure?\n\nYou are about to delete the company ',
          'CANCELAR': 'Cancel',
          'CONFIRMAR': 'Yes, remove',
          'SUCCES': 'Company eliminated',
          'CERRAR': 'Close'
        },
        'LOG_SENDGRIND':{
          'CARGANDO': 'Loading data, please wait...',
          'ASUNTO': 'You must select a subject',
          'CONFIRMAR': 'Close'
        }
      }
    }
};
